// extracted by mini-css-extract-plugin
export default {"list":"ArticleList_list__eFm-G","grid":"ArticleList_grid__uwvrC","item":"ArticleList_item__aCWpz"};